import React from 'react'
import apiBarcode from '../../services/api/apiBarcode'
import apiPF126 from '../../services/api/apiPF126'
import StatisticsView from './StatisticsView'
import "./styles/index.scss"


class Home extends React.Component {
    state = {
        notPrinted: '--',
        notPacked: '--',
        inProcessing: '--'
    }

    componentDidMount() {
        this._fetchStatistics()
    }

    _fetchStatistics = async () => {
        try {
            const resRead = await apiBarcode.getStatistics()
            const {success, data, message} = resRead.data
            if (!success) throw new Error(message)
            const {notPrinted, notPacked} = data
            const pf126_data = await apiPF126.getStatistics()
            const inProcessing = pf126_data.data.data
            this.setState({notPrinted, notPacked, inProcessing})
        } catch (e) {
            alert(e.message)
        }
    };

    render() {
        const {notPrinted, notPacked, inProcessing} = this.state
        const statistics = {notPrinted, notPacked, inProcessing}
        return (
            <div className='Home'>
                <StatisticsView statistics={statistics}/>
            </div>
        )
    }
}

export default Home;